export const calendarViewTranslations = {
    en: {
        // Days of the week
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",

        // Tooltips
        today: "Today",
        campaigns: "Campaigns",

        // Labels
        campaign: "Campaign",
        totalCamps: "Total Camps",
        activeCamps: "Active Camps",
        selectADate: "Select a Date",

        // Table Headers
        campName: "Camp Name",
        campCode: "Camp Code",
        district: "District",
        startDate: "Start Date",
        type: "Type",

        // Messages
        noCampaignsScheduledMonth: "No campaigns scheduled for this month",
        noActiveCampaignsDate: "No active campaigns on this date",
    },
    mr: {
        // Days of the week
        sunday: "रविवार",
        monday: "सोमवार",
        tuesday: "मंगळवार",
        wednesday: "बुधवार",
        thursday: "गुरुवार",
        friday: "शुक्रवार",
        saturday: "शनिवार",

        // Tooltips
        today: "आज",
        campaigns: "मोहिमा",

        // Labels
        campaign: "मोहीम",
        totalCamps: "एकूण शिबिरे",
        activeCamps: "सक्रिय शिबिरे",
        selectADate: "तारीख निवडा",

        // Table Headers
        campName: "शिबिराचे नाव",
        campCode: "शिबिर कोड",
        district: "जिल्हा",
        startDate: "प्रारंभ तारीख",
        type: "प्रकार",

        // Messages
        noCampaignsScheduledMonth: "या महिन्यासाठी कोणतीही शिबिरे नियोजित नाहीत",
        noActiveCampaignsDate: "या तारखेला कोणतीही सक्रिय शिबिरे नाहीत",
    }
};
